export default __webpack_public_path__ + "static/media/Calender.3d04b37f.svg";